
<template>
  <Page>
    <div class="advancedQuery" ref="adQ">
        <div class="van-collapse-item__content" >
                    <!-- 课程名称 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程名称：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[0]['name']"
                            placeholder="请输入课程名称"
                            oninput="if(value.length>80)value=value.slice(0,80)"
                        >
                    </div>
                    <!-- 课程类型 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(1)">
                            {{pullList[1]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 导师类型 -->                    
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">导师类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(2)">
                            {{pullList[2]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                     <!-- 培训导师 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">培训导师：</div>
                        <div class="pull-down-selects" data-id="10" >
                            <input
                                type="text"
                                class="inputs"
                                v-model="pullList[3]['name']"
                                placeholder="请输入培训导师"
                                oninput="if(value.length>50)value=value.slice(0,50)"
                            >
                        </div>
                    </div> 

                    <!-- 课程日期 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one titles">课程日期：</div>
                        <div class="birthday-flex-style-one" @click="downSelections(4)">
                            {{pullList[4]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="birthday-flex-style-one" @click="downSelections(5)">
                            {{pullList[5]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 国家 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">国家：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(6)">
                            {{pullList[6]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>   
                    <!-- 城市 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">城市：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(7)">
                            {{pullList[7]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>  
                    <!-- 地点 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">地点：</div>
                        <textarea
                            type="text"
                            class="inputs"
                            v-model="pullList[8]['name']"
                            placeholder="请输入详情地址"
                            oninput="if(value.length>254)value=value.slice(0,254)"
                        />
                    </div>
                    <!-- 学员类型 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">学员类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(9)">
                            {{pullList[9]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                    <!-- 学员人数 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one titles">学员人数：</div>
                        <div class="birthday-flex-style-one">
                            <input
                            type="number"
                            class="inputs"
                            v-model="pullList[10]['name']"
                            placeholder="开始人数"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                        </div>
                        <div>-</div>
                        <div class="birthday-flex-style-one">
                            <input
                            type="number"
                            class="inputs"
                            v-model="pullList[11]['name']"
                            placeholder="结束人数"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                        </div>
                    </div>
                    <!-- 学员类型 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程费用币种：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(12)">
                            {{pullList[12]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                    <!-- 单人费用 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one titles">单人费用：</div>
                        <div class="birthday-flex-style-one">
                            <input
                            type="number"
                            class="inputs"
                            v-model="pullList[13]['name']"
                            placeholder="开始单人费用"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                        </div>
                        <div>-</div>
                        <div class="birthday-flex-style-one">
                            <input
                            type="number"
                            class="inputs"
                            v-model="pullList[14]['name']"
                            placeholder="结束单人费用"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                        </div>
                      </div>  
                    <!-- 费用合计 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one titles">费用合计：</div>
                        <div class="birthday-flex-style-one">
                            <input
                            type="number"
                            class="inputs"
                            v-model="pullList[15]['name']"
                            placeholder="开始费用"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                        </div>
                        <div>-</div>
                        <div class="birthday-flex-style-one">
                            <input
                            type="number"
                            class="inputs"
                            v-model="pullList[16]['name']"
                            placeholder="结束费用"
                           oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                        </div>
                    </div>
                    <!-- 提交作品 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">提交作品：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(17)">
                            {{pullList[17]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 

        </div>


            <!-- 下拉筛选 -->
            <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection"
                    @cancel="onCancelCode"
                    @confirm="onConfirmCode"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
            <!-- 时间筛选 -->
            <van-popup v-model="showTimeSelection" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                @cancel="onCancelTime"
                @confirm="onConfirmTime"
                :min-date="minDate"
              />
            </van-popup>

    </div>
    <!-- 底部按钮 -->
    <div class="bottom_btn">
      <div class="bottom_btn1" @click="bottom_btn1">清空</div>
      <div class="bottom_btn2" @click="bottom_btn2">搜索</div>
    </div>
  </Page>
</template>

<script>
let dictionary = {},
  findContuny;
import { Toast } from "vant";
export default {
  name: "queryCurriculum",
  data() {
    return {
      startDate: null,
      endDate: null, //结束日期
      neededShow: null,
      currentDate: new Date(), // 时间
      minDate: new Date(new Date() - 365 * 10 * 24 * 60 * 60 * 1000), // 最小时间
      timeShow: false, // 时间展示
      title: "课程高级查询",
      Curriculumdata: [
        {
          name: "课程名称",
          form: "",
          attribute: "courseName",
          type: "textarea",
          required: true,
          show: false,
          input: true,
          value: null,
          pickerList: []
        },
        {
          name: "课程类型",
          type: "textarea",
          form: "请选择",
          attribute: "courseType",
          pickerList: [],
          required: true,
          value: null,
          show: false
        },
        {
          name: "导师类型",
          form: "请选择",
          attribute: "teacherId",
          type: "textarea",
          pickerList: [
            "中国徕卡学院导师",
            "全球徕卡学院导师",
            "马格南大师",
            "其他导师"
          ],
          required: true,
          value: null,
          show: false
        },
        {
          name: "培训导师",
          form: "请选择",
          attribute: "tutorial",
          type: "textarea",
          pickerList: [],
          value: null,
          required: true,
          show: false
        },
        {
          name: "课程日期",
          form: "请选择",
          attribute: "rangeTime",
          type: "textarea",
          pickerList: [],
          required: true,
          value: null,
          pickerList: [],
          show: false
        },
        {
          name: "国家",
          form: "请选择",
          attribute: "country",
          type: "textarea",
          pickerList: [],
          required: true,
          value: null,
          show: false
        },
        {
          name: "城市",
          type: "textarea",
          attribute: "city",
          form: "请选择",
          pickerList: [],
          required: true,
          value: null,
          show: false
        },
        {
          name: "地点",
          type: "textarea",
          form: "",
          attribute: "address",
          pickerList: [],
          required: true,
          value: null,
          input: true,
          show: false
        },
        {
          name: "学员类型",
          type: "textarea",
          form: "请选择",
          attribute: "studentType",
          pickerList: [],
          value: null,
          required: true,
          show: false
        },
        {
          name: "学员人数",
          type: "number",
          form: "",
          attribute: "studentCnt",
          pickerList: [],
          required: true,
          show: false,
          value: null,
          input: true
        },
        {
          name: "币种",
          type: "textarea",
          form: "请选择",
          attribute: "currency",
          pickerList: [],
          required: true,
          value: null,
          show: false
        },
        {
          name: "单人费用",
          type: "number",
          form: "",
          attribute: "price",
          pickerList: [],
          required: true,
          show: false,
          value: null,
          input: true
        },
        {
          name: "费用合计",
          type: "number",
          form: "",
          attribute: "amount",
          pickerList: [],
          required: true,
          show: false,
          input: true,
          value: null
        },
        {
          name: "提交作品",
          type: "",
          form: "",
          attribute: "",
          pickerList: ['全部','需要','不需要'],
          required: true,
          value: null,
          show: false
        }
      ],
      rangeTimeindex: 0,
      height:0,


    ///////////////////////////-   重置  -////////////////////////////////
    // 字典表查询code
    codeList:['teacherType','StudentType','Classes','Country','CourseCity','Currency'],
    teacherTypeList:[], //导师类型
    studentTypeList:[], //学员类型  
    courseTypeList:[],  //全部课程
    CountryList:[],     //国家
    CourseCityList:[],  //城市
    CurrencyList:[],    //币种
    supervisorList:[],  //培训导师 
    NeedList:[{name:"全部",value:""},{name:"需要",value:"1"},{name:"不需要",value:"0"},],        //提交作品

    courseType:"",   //课程类型
    teacherType:"",  //导师类型
    studentType:"",  //学员类型
    courseName:"",   //课程名称
    teacherId:"",    //培训导师
    startDate:"",    //课程开始日期
    endDate:"",      //课程结果日期
    city:"",         //城市
    startStudentCnt:"",  //学员开始人数
    endStudentCnt:"",    //学员结束人数
    currency:"",         //课程费用币种
    startPrice:"",       //单人费用开始费用
    endPrice:"",         //单人费用结束费用
    startAmount:"",      //费用合计开始
    endAmount:"",        //费用合计结束
    neededShow:"",       //是否需要提交作品
    address:"",          //地点
    country:"",          //国家
    pullList: [
        {name:"",val:""}, //课程名称
        {name:"",val:""}, //课程类型
        {name:"",val:""}, //导师类型
        {name:"",val:""}, //培训导师
        {name:"",val:""}, //课程开始日期
        {name:"",val:""}, //课程结果日期
        {name:"",val:""}, //国家
        {name:"",val:""}, //城市
        {name:"",val:""}, //地点
        {name:"",val:""}, //学员类型
        {name:"",val:""}, //学员开始人数
        {name:"",val:""}, //学员结束人数
        {name:"",val:""}, //课程费用币种
        {name:"",val:""}, //单人费用开始费用
        {name:"",val:""}, //单人费用结束费用
        {name:"",val:""}, //费用合计开始
        {name:"",val:""}, //费用合计结束    
        {name:"",val:""}, //是否需要提交作品      
      ], 
    showDownSelection:false ,  //下拉菜单展示
    showTimeSelection:false,   //下拉时间栏
    downSelection:[],          //下拉菜单列表数据
    downSelectionVal:0,        //当前索引

    };

  },
  methods: {
    /**
     * @name 初始化 获取字典参数
     *
     */
    async init_dictionary() {
      try {
        let { sendSync, get } = this.$api;
        //查询全部的字典KEY
        let dictall = await get("api/dict/all", {});
        if (dictall.success) {
          for (const iterator of dictall.data) {
            Object.assign(dictionary, {
              [`${iterator.tname}`]: iterator.tcode
            });
          }
        } else {
          Toast(dictall.msg);
          return;
        }
        //查询国家
        let contuny = await get("api/common/contuny", {});
        if (!contuny.success) {
          Toast(contuny.msg);
          return;
        }
        findContuny = contuny.data;
        //根据字典Code查询字典项
        //根据上级区域ID查询区域列表
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    },
    //点击取消按钮时触发
    async onCancel(item_index) {
      try {
        console.log(item_index);
        this.Curriculumdata[item_index].show = false;
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    },
    //点击完成按钮时触发
    async onConfirm(value, item_index) {
      try {
        console.log(value, item_index);
        this.Curriculumdata[item_index].show = false;
        if (this.moment.isDate(value)) {
          let value = this.moment(value).format("YYYY/MM/DD");
          this.Curriculumdata[item_index].form = value;
          this.Curriculumdata[item_index].value = value;
          return;
        }
        if (typeof value == "object") {
          this.Curriculumdata[item_index].form = value.name;
          this.Curriculumdata[item_index].value = value.value || value.id;
          return;
        }
        this.Curriculumdata[item_index].form = value;
        this.Curriculumdata[item_index].value = value.value;
        //提交作品
        if(item_index==13){
            value=="全部"?this.neededShow='':value=="需要"?this.neededShow=1:this.neededShow=2;
        }
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    },
    //选择器显示
    async pickerClick(item_index, items, rangeTimeindex) {
      console.log("当前索引",item_index)
      try {
        console.log(item_index, items);
        //事件选择器
        if ("rangeTime" == items.attribute) {
          this.rangeTimeindex = rangeTimeindex;
          this.timeShow = true;
          return;
        }
        let { sendSync, get } = this.$api;
        let tcode;
        if ("课程类型" == items.name) {
          tcode = dictionary[`感兴趣课程&课程类型`];
        } else if ("培训导师" == items.name) {
          tcode = dictionary[`导师类型`];
        } else {
          tcode = dictionary[`${items.name}`];
        }
        console.log("点击上传code",tcode)

        //根据字典Code查询字典项
        let queryByTcode = await get(
          "api/dict/queryByTcode?tcode=" + tcode,
          {}
        );

        console.log("code===",queryByTcode)
        
        if (!queryByTcode.success) {
          Toast(queryByTcode.msg);
          return;
        }
        if (items.name == "城市") {
          console.log(this.Curriculumdata[item_index - 1]);
          let pid = this.Curriculumdata[item_index - 1].pickerList.map(v => {
            if (v.name == this.Curriculumdata[item_index - 1].form) {
              return v.value;
            } else {
              return null;
            }
          });
          //根据上级区域ID查询区域列表
          let locals = await get("api/common/locals", {});
          if (!locals.success) {
            Toast(locals.msg);
            return;
          }
          queryByTcode.data = locals.data;
        }
         queryByTcode.data=[{name:"全部",id:"",value:''}].concat(queryByTcode.data);
        this.Curriculumdata[item_index].pickerList = queryByTcode.data;
        console.log("改变后的数组", this.Curriculumdata[item_index].pickerList)
        //追加提交作品
        if(item_index==13){
        this.Curriculumdata[item_index].pickerList =  ['全部','需要','不需要']; 
        } 

        this.Curriculumdata[item_index].show = true;
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    },
    //导航栏返回
    async onClickLeft() {
      this.$toast("导航栏返回");
      this.$router.back(-1);
    },
    //导航栏更多
    async onClickRight() {
      this.$toast("导航栏更多");
      this.$router.back(1);
    },
    async onCancels(item_index) {
      try {
        console.log(item_index);
        this.timeShow = false;
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    },
    //点击完成按钮时触发
    async onConfirms(value, item_index) {
      try {
        console.log(value, item_index, this.rangeTimeindex);
        let time = this.moment(value).format("YYYY-MM-DD");
        this.Curriculumdata[item_index].form = time;
        if (this.rangeTimeindex == 1) {
          this.startDate = time;
        } else {
          this.endDate = time; //结束日期
        }
        this.timeShow = false;
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    },

    /**
     * 
     * =====================================================================================
     *                                        重置
     * =====================================================================================
     * 
     */
    // 拉下    确定 取消
    onCancelCode(){ this.showDownSelection=false; },  
    onConfirmCode(val){
         console.log("确定按钮",val)
         console.log("**********",this.downSelectionVal);
         console.log("----------",this.pullList[this.downSelectionVal])
         this.pullList[this.downSelectionVal]['name']=val.name;
         this.pullList[this.downSelectionVal]['value']=val.value;
         this.showDownSelection=false;
         if(this.downSelectionVal==2){
          this.getCourseTeacherInfo(this.pullList[this.downSelectionVal]['value']);
         }
    },
    // 时间    确定 取消
    onCancelTime(){ this.showTimeSelection=false; },  
    onConfirmTime(val){
            this.pullList[this.downSelectionVal]['name']=this.$time(val);
            this.pullList[this.downSelectionVal]['value']=this.$time(val);
            this.showTimeSelection=false;
    },
    downSelections(index){
      this.downSelectionVal=index;
      if(index==1||index==2||index==3||index==6||index==7||index==9||index==12||index==17){  
        switch(index){
          case   1     :    this.downSelection=this.setCodeAlls(this.courseTypeList);break
          case   2     :    this.downSelection=this.setCodeAlls(this.teacherTypeList);break
          case   3     :    this.downSelection=this.setCodeAlls(this.supervisorList);break
          case   6     :    this.downSelection=this.setCodeAlls(this.CountryList);break
          case   7     :    this.downSelection=this.pullList[6]['value']=='10'?this.setCodeAlls(this.CourseCityList):[{value: "50", name: "其他", code: "Others", sort: -1}];break
          case   9     :    this.downSelection=this.setCodeAlls(this.studentTypeList);break
          case   12    :    this.downSelection=this.setCodeAlls(this.CurrencyList);break
          case   17    :    this.downSelection=this.NeedList;break
        }
        this.showDownSelection=true;
      }else{
        this.showTimeSelection=true;
      }  
    },
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            console.log("字典表返回"+this.codeList[i],Response)
            switch (this.codeList[i]) {
              case "Classes"                 :  this.courseTypeList = Response.data;break;
              case "teacherType"             :  this.teacherTypeList = Response.data;break;
              case "StudentType"             :  this.studentTypeList = Response.data;break;
              case "Country"                 :  this.CountryList = Response.data;break; 
              case "CourseCity"              :  this.CourseCityList = Response.data;break;
              case "Currency"                :  this.CurrencyList = Response.data;break;
            }
          });
      }
    },
    // 查询导师
    getCourseTeacherInfo(ID){
      this.$api.getCourseTeacherInfo({salesId: this.$wxuserUtil.getUserId(),teacherType:ID}).then(Response=>{
           console.log("查询导师",Response)
           if(Response.success){
              for(let i=0;i<Response.data.length;i++){
                  Response.data[i]['value']= Response.data[i]['teacherId'];
              }
              this.supervisorList= Response.data;
           }
      })
    },
    //取消
    bottom_btn1(index) {
       this.toEmpty();
    },
    //确认
    bottom_btn2() {
       if(this.compareDate(this.pullList[4]['name'],this.pullList[5]['name'])==false){
         this.$title("开始日期大于结束日期")
         return;
       }

        let obj={
           courseName:this.pullList[0]['name']||'',
           courseTypes:this.pullList[1]['value']||'',
           teacherId:this.pullList[2]['value']||'',
           tutorial:this.pullList[3]['name']||'',
           startDate:this.pullList[4]['name']||'',
           endDate:this.pullList[5]['name']||'',
           country:this.pullList[6]['value']||'',
           city:this.pullList[7]['value']||'',
           address:this.pullList[8]['name']||'',
           courseType:this.pullList[9]['value']||'',
           studentCnt:this.pullList[10]['name']||'',
           studentCnts:this.pullList[11]['name']||'',
           currency:this.pullList[12]['value']||'',
           price:this.pullList[13]['name']||'',
           prices:this.pullList[14]['name']||'', 
           amount:this.pullList[15]['name']||'',
           amounts:this.pullList[16]['name']||'',
           neededShow:this.pullList[17]['value']||''
        }


        this.$router.push({ name: "listCurriculum", params: obj });
    },
   /**
    * 
    *   添加全部
    * 
    */
   setCodeAlls(data){
      if(Array.isArray(data)){
        return  [{name:"全部",value:""}].concat(data);  
      }else{
        return  [].concat(data);
      }
   },
   compareDate(checkStartDate, checkEndDate) {      
    var arys1= new Array();      
    var arys2= new Array();      
    if(checkStartDate != null && checkEndDate != null) {      
        arys1=checkStartDate.split('-');      
          var sdate=new Date(arys1[0],parseInt(arys1[1]-1),arys1[2]);      
        arys2=checkEndDate.split('-');      
        var edate=new Date(arys2[0],parseInt(arys2[1]-1),arys2[2]);      
    if(sdate > edate) {            
        return false;         
    }  else {   
        return true;      
        }   
     }      
  },
    //清空全部
  toEmpty(){
    for(let i=0;i<this.pullList.length;i++){
       this.pullList[i]['name']='';
       this.pullList[i]['value']='';
    }
  }, 
  },
  mounted() {
        this.$refs.adQ.style.height=localStorage.getItem('heights')-40+'px';
        this.getQueryByTcode();
  },
  created() {
    /**
     * 初始化字典数据
     *
     */
    this.init_dictionary();
  },
  watch: {},
  components: {}
};
</script>
<style lang="less"  scoped src="~p/pageView-filter.less"></style>  
<style lang="less" scoped>
@import url("../../style/componentStyle/index-Page.less");

.titles{
  color:#0d0d0d;
}
.filtrate > img {
  width: 1rem;
  height: 1rem;
  background: white;
}
.rowinput {
  height: 0.9rem;
  background-color: #f6f6f6;
  color: rgba(13, 13, 13, 1);
  font-size: 14px;
  text-align: left;
  border: none;
}
.radio_group-item{
  font-size: .3rem;
}
.rowlabel {
  height: 1rem;
  line-height: 1rem;
  font-size: 14px;
  color: rgba(13, 13, 13, 1);
  font-family: "PingFangSC-regular";
  font-weight: normal;
  padding-left: .3rem;
}
.rowcontent-item{
    -ms-flex-item-align: center;
  align-items: center;
}
.rowcontent {
  margin-top: 0.15rem;
  width: 100%;
  background-color: #f6f6f6;
  text-align: left;
  -ms-flex-item-align: center;
  align-items: center;
}
.advancedQuery {
  background: #ffffff;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .van-cell-group-flex{
          overflow-y: auto;
  }
  .van-cell-group-flex-cell{
      overflow-y: auto;
  }
.birthday-flex-style-one{
  width:2.7rem;
    input{
      width:2.5rem;
    }
}  
}
.last-bottom{
  margin-bottom: 1.5rem;
}
.bottom_btn {
  position: fixed;
  bottom: 0rem;
  width: 100%;
  height: 38px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.bottom_btn2,
.bottom_btn1 {
  width: 50%;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 0.35rem;
}
.bottom_btn1 {
  background: #222222;
  color: #fff;
}
.bottom_btn2 {
  background: #e10913;
  color: #fff;
}
.downimg {
  position: absolute;
  right: 0.2rem;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: -0.6rem;
}
.group,
.radio_group {
  background-color: #f6f6f6;
  width: 100%;
}
.genderRadio-flex {
  .van-radio-group {
    display: flex;
    width: 4rem;
    flex-direction: row;
    justify-content: space-between;
    //  margin: .5rem auto;
    font-size: 0.2rem;
  }
}
.downimgdate {
  width: 0.3rem;
  height: 0.3rem;
}
.item-flex{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  -ms-flex-item-align: center;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/lkcollege/queryCurriculum.vue